<template>
  <div>
    <v-card>
      <v-card-title>{{ $t('Team members') }}</v-card-title>
      <v-card-subtitle>{{ $t('All of the people that are part of this team') }}</v-card-subtitle>
      <v-list two-line>
        <v-list-item
          v-for="member in members"
          :key="member.id"
        >
          <v-list-item-content>
            <v-list-item-title v-if="member.name">
              {{ member.name }}
              <template v-if="member.id === $page.props.user.id">
                ({{ $t('You') }})
              </template>
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ member.email }}
              <template v-if="member.id === $page.props.user.id">
                ({{ $t('You') }})
              </template>
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action v-if="member.id === $page.props.user.id">
            <v-btn
              small
              color="error"
              :loading="leaveTeamForm.processing"
              :disabled="leaveTeamForm.processing"
              @click="leaveTeam"
            >
              {{ $t('Leave') }}
            </v-btn>
          </v-list-item-action>

          <v-list-item-action v-if="permissions.canRemoveTeamMembers">
            <v-btn
              small
              color="error"
              :loading="removeTeamMemberForm.processing"
              :disabled="removeTeamMemberForm.processing"
              @click="removeTeamMember(member)"
            >
              {{ $t('Remove') }}
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    team: {
      type: Object,
      required: true
    },
    members: {
      type: Array,
      required: true
    },
    permissions: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      leaveTeamForm: this.$inertia.form({}),
      removeTeamMemberForm: this.$inertia.form({})
    }
  },

  methods: {
    leaveTeam() {
      const url = this.route('team-members.destroy', [this.team, this.$page.props.user]);
      this.leaveTeamForm.delete(url, {
        preserveScroll: true
      });
    },

    removeTeamMember(member) {
      const url = this.route('team-members.destroy', [this.team, member.id]);
      this.removeTeamMemberForm.delete(url, {
        preserveScroll: true
      });
    }
  }
}
</script>